import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { AddArticleScreen } from "../components";
import usePermission from "@/hooks/usePermission";

export const AddArticle = () => {
  const { showArticle } = usePermission();

  return (
    <ContentLayout title="Add Article" showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
            policyCheck={showArticle}
          >
            <AddArticleScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
